var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container_logo"},[_c('v-img',{staticClass:"logo",attrs:{"src":_vm.logo,"transition":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }